// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hidden-columns-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.hidden-columns-modal__title {
  margin: 0;
  text-align: center;
}

.hidden-columns-modal__description {
  margin: 8px 0 12px;
  text-align: center;
}

.hidden-columns-modal__table-wrap {
  width: 100%;
  min-height: 0;
  flex: 1 1 auto;
  overflow-x: auto;
  overflow-y: hidden;
}

.hidden-columns-modal__actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Components/KpFinHiddenColumns/KpFinHiddenColumns.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,SAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,QAAA;EACA,gBAAA;AACF","sourcesContent":[".hidden-columns-modal {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  padding: 12px;\n  box-sizing: border-box;\n}\n\n.hidden-columns-modal__title {\n  margin: 0;\n  text-align: center;\n}\n\n.hidden-columns-modal__description {\n  margin: 8px 0 12px;\n  text-align: center;\n}\n\n.hidden-columns-modal__table-wrap {\n  width: 100%;\n  min-height: 0;\n  flex: 1 1 auto;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n\n.hidden-columns-modal__actions {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
